import React from "react";

import { Row, Col } from "react-grid-system";
import styled from "styled-components";
import { Product as P } from "./IDs.js";

import icoChevron from "./../img/ico-chevron.svg";

export const TYPE_DAILY = "TYPE_DAILY";
export const TYPE_MONTHLY = "TYPE_MONTHLY";

export const list = [
  // DAILY
  {
    from: "1-DAY ACUVUE MOIST",
    to: P.Premium_Daily_Spheric,
    type: TYPE_DAILY,
  },
  {
    from: "1-Day ACUVUE Moist for Astigmatism",
    to: P.Platinum_Daily_Toric,
    type: TYPE_DAILY,
  },
  {
    from: "1-Day ACUVUE TruEye",
    to: P.Platinum_Daily_Spheric,
    type: TYPE_DAILY,
  },
  {
    from: "Acuvue Oasys 1-Day",
    to: P.Platinum_Daily_Spheric,
    type: TYPE_DAILY,
  },
  {
    from: "BioMedics 1 day Extra",
    to: P.Comfort_Daily_Spheric,
    type: TYPE_DAILY,
  },
  { from: "Biotrue ONEday", to: P.Premium_Daily_Spheric, type: TYPE_DAILY },

  {
    from: "DAILIES AquaComfort Plus Toric",
    to: P.Platinum_Daily_Toric,
    type: TYPE_DAILY,
  },
  { from: "Dailies Total 1", to: P.Platinum_Daily_Spheric, type: TYPE_DAILY },
  { from: "Focus DAILIES", to: P.Comfort_Daily_Spheric, type: TYPE_DAILY },
  {
    from: "Focus DAILIES AquaComfort Plus",
    to: P.Premium_Daily_Spheric,
    type: TYPE_DAILY,
  },
  {
    from: "Oasys 1-Day for Astigmatism",
    to: P.Platinum_Daily_Toric,
    type: TYPE_DAILY,
  },
  {
    from: "SofLens Daily Disposable",
    to: P.Comfort_Daily_Spheric,
    type: TYPE_DAILY,
  },
  // MONTHLY
  {
    from: "ACUVUE Oasys for Astigmatism",
    to: P.Premium_Monthly_Toric,
    type: TYPE_MONTHLY,
  },
  {
    from: "Air Optix Aqua Multifocal",
    to: P.Premium_Monthly_Multifocal,
    type: TYPE_MONTHLY,
  },
  {
    from: "Air Optix for Astigmatism",
    to: P.Premium_Monthly_Toric,
    type: TYPE_MONTHLY,
  },
  {
    from: "Air Optix HydraGlyde",
    to: P.Premium_Monthly_Spheric,
    type: TYPE_MONTHLY,
  },
  { from: "Biofinity", to: P.Premium_Monthly_Spheric, type: TYPE_MONTHLY },
  {
    from: "Biofinity Multifocal",
    to: P.Premium_Monthly_Multifocal,
    type: TYPE_MONTHLY,
  },
  {
    from: "Biofinity Toric",
    to: P.Premium_Monthly_Toric,
    type: TYPE_MONTHLY,
  },
  {
    from: "BioMedics 55 Evolution",
    to: P.Comfort_Monthly_Spheric,
    type: TYPE_MONTHLY,
  },
  {
    from: "Contact Day 30 Spheric",
    to: P.Comfort_Monthly_Spheric,
    type: TYPE_MONTHLY,
  },
  { from: "PureVision 2", to: P.Premium_Monthly_Spheric, type: TYPE_MONTHLY },
  {
    from: "PureVision2 Presbyopia",
    to: P.Premium_Monthly_Multifocal,
    type: TYPE_MONTHLY,
  },
  { from: "SofLens 59", to: P.Comfort_Monthly_Spheric, type: TYPE_MONTHLY },
];

const DropdownWrap = styled.div`
  display: inline-block;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    right: 1.8rem;
    top: 50%;
    transform: translateY(-50%);
    width: 11px;
    height: 6px;
    background: url(${icoChevron});
    background-size: 100%;
  }
`;

const Dropdown = styled.select`
  background: white;
  border: 1px solid #a5b2bf;
  color: #a5b2bf;
  padding: 1rem 2rem 1rem 1.8rem;
  @media (max-width: 600px) {
    padding-left: 1.8rem;
    padding-right: 1.6rem;
  }
  appearance: none;
`;

export const render = ({ dispatch, type = null }) => {
  const arr = list.filter(v => (type ? v.type === type : true));
  return (
    <Row className="w-100">
      <Col
        className="mt1 center px0"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <DropdownWrap>
          <Dropdown id="productSelect" data-to={"coucou"}>
            {arr.map((a, i) => {
              return (
                <option
                  className="productSelectOption"
                  key={`${a.from}-${i}`}
                  value={a.from}
                  data-from={a.from}
                  data-to={a.to}
                >
                  {a.from}
                </option>
              );
            })}
          </Dropdown>
        </DropdownWrap>

        <div className="block py1 mt3">
          <button
            className="btn"
            onClick={() => {
              const i = document.getElementById("productSelect").selectedIndex;
              const $options = document.getElementsByClassName(
                "productSelectOption"
              );
              const type = $options[i].getAttribute("data-to");
              dispatch({ type });
            }}
          >
            Meine passende Kontaktlinse anzeigen
          </button>
        </div>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/Wizard/ComparableProducts.js